import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TabKeyType } from './event-base-automation';

import { EbaStatusType } from '@/models/automation.model';

export type EbaGroupStateMapType = Record<TabKeyType, EbaStatusType>;
export interface EbaGroupStateType {
  groupStatus: EbaGroupStateMapType;
}

const initialState: EbaGroupStateType = {
  groupStatus: {
    active: {},
    inactive: {},
  },
};

const EbaGroupStore = createSlice({
  name: 'event-automation-group',
  initialState,
  reducers: {
    setGroupIds: (state, action: PayloadAction<EbaGroupStateType['groupStatus']>) => {
      state.groupStatus = action.payload;
    },
  },
});

export const { setGroupIds } = EbaGroupStore.actions;

export default EbaGroupStore.reducer;
